module.exports = __webpack_public_path__ + "img/mbxz.0cddb1f5.svg";